import { Injectable } from '@angular/core';
import {DataService} from "../../../../services/external-api/data.service";
import {ApiService} from "../../../../services/external-api/api.service";
import {Presenter} from "../../../internal/presenter/presenter";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {Observable, of} from "rxjs";
import {emptyWorkflowAction, emptyWorkflowForm, emptyWorkflowProcessStage, emptyWorkflowProcessType, emptyWorkflowProcessVariable, IWorkflowAction, IWorkflowProcessStage, IWorkflowProcessType, IWorkflowProcessVariable, IWorkflowTask} from "@retail-data-factory/rdf-angular-types-api";
import {map} from "rxjs/operators";
import {mapProcessTypeFromService, mapTaskFromService} from "../api-workflow/mapping-functions/mapping-rdf";
import {IServiceResponse} from "../../../../services/external-api/response-interfaces";
import * as moment from "moment";
import {ApiWorkflowService} from "../api-workflow/api-workflow.service";
import {mapAuchanTaskFromService} from "../api-workflow/mapping-functions/mapping-auchan";

@Injectable({
  providedIn: 'root'
})
export class ApiWorkflowV2Service {

  constructor(
    private dataService: DataService,
    private apiService: ApiService,
    private presenter: Presenter,
    private apiWorkflowService: ApiWorkflowService,
    private configurationManager: ConfigurationManager

  ) { }

  getProcessTypes():Observable<Array<IWorkflowProcessType>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions`, param).pipe(
      map(result => {
        console.log(result);
        const processTypes: Array<IWorkflowProcessType> = result.report.map(t => mapProcessTypeFromService(t));
        return processTypes;
      })
    );
  }

  getProcessType(processTypeId: string):Observable<IWorkflowProcessType>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions/${processTypeId}`, param).pipe(
      map(result => {
        return result.report.length? mapProcessTypeFromService(result.report[0]):{...emptyWorkflowProcessType};
      })
    );
  }

  createProcessType(idExt: string, code: string, name: string, description: string, statusCode: string, profile: object):Observable<IServiceResponse>{
    const param = {};
    const body = {
      'id_ext': idExt,
      'process_definition_code': code,
      'process_definition_name': name,
      'process_definition_description': description,
      'process_definition_status_code': statusCode,
      'profile': profile
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions`, param, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }
  updateProcessType(idProcessType: string, idExt: string, code: string, name: string, description: string, statusCode: string, profile: object):Observable<IServiceResponse>{
    const param = {};
    const body = {
      'id_ext': idExt,
      'process_definition_code': code,
      'process_definition_name': name,
      'process_definition_description': description,
      'process_definition_status_code': statusCode,
      'profile': profile
    };
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions/${idProcessType}`, param, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }


  getProcessTypeStages(processTypeId: string, stageTypeCode = ''): Observable<Array<IWorkflowProcessStage>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions/${processTypeId}/stages`, param).pipe(
      map(result => {
        if (stageTypeCode) {
          return result.report
            .filter(item=>item['type_code']===stageTypeCode)
            .map(item=>this.mapStageFromService(item));
        }else{
          return result.report.map(item=>this.mapStageFromService(item));
        }

      })
    );
  }

  getProcessTypeStage(processTypeId: string, progressStageId: string): Observable<IWorkflowProcessStage>{
    const param = {};
    // return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions/${processTypeId}/stages/${progressStageId}`, param).pipe(
    // map(result => {
    //   return result.report.length?this.mapStageFromService(result.report[0]):{...emptyWorkflowProcessStage};
    // })
    // );



     return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions/${processTypeId}/stages`, param).pipe(
      map(result => {
        const r = result.report.find(t=>t.id === progressStageId);
        if (r) {
          return this.mapStageFromService(r);
        }else{
          return {...emptyWorkflowProcessStage};
        }


        //return result.report.length?this.mapStageFromService(result.report[0]):{...emptyWorkflowProcessStage};
      })
    );
  }
  getProcessTypeRoutes(processTypeId: string, progressStageId: string): Observable<Array<IWorkflowAction>>{
    const param = {};
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions/${processTypeId}/stages/${progressStageId}/routes`, param).pipe(
      map(result => {
        const routes: Array<IWorkflowAction> = result.report.map(t=>({...emptyWorkflowAction,
          id: t.route_id,
          title: t.name,
          buttonType: t.profile && t.profile.buttonType?t.profile.buttonType:'0',
          profile: t.profile
        }));
        return routes;
      })
    );
  }

  startProcess(processName: string, processDescription: string, processTypeId: string, routeId: string, processProfile: object = null, taskProfile:object = null):Observable<IServiceResponse>{
    const param = {};
    const body = {
      'name': processName,
      'description': processDescription,
      'route_id': routeId,
      'profile': processProfile,
      'task_profile': taskProfile
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/process-definitions/${processTypeId}/processes`, param, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }


  getProcesses(processTypeId?: string) {
    return this.apiWorkflowService.getProcesses();
  }
  getProcess(processId: string) {
    return this.apiWorkflowService.getProcess(processId);
  }


  getTasks(processTypeId: string, searchString?:string): Observable<Array<IWorkflowTask>> {
    const param = {
      process_type: processTypeId ? processTypeId : '-'
    };

    const searchStr = `?search=${searchString?searchString:''}`;

    console.log(param);
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/tasks${searchStr}`, param).pipe(
      map(result => {
        console.log(result);
        const tasks: Array<IWorkflowTask> = result.report.map(item => {
            return mapTaskFromService(item);
        });
        return tasks;
      })
    );
  }
  getTask(taskId: string):Observable<IWorkflowTask> {
    return this.apiWorkflowService.getTask(taskId);
  }

  completeTask(taskId: string, routeId: string){
    const param = {};
    const body = { };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/tasks/${taskId}/routes/${routeId}`, param, null).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );

  }


  getProcessTasks(processId: string): Observable<Array<IWorkflowTask>> {
    return this.apiWorkflowService.getProcessTasks(processId);
  }



  getProcessVariables(processId: string): Observable<Array<IWorkflowProcessVariable>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflow2Url')}/processes${processId}/variables`, {}).pipe(
      map(
        result=>{
          const variables: Array<IWorkflowProcessVariable> = result.report.map(item=>this.mapVariableFromService(item));
          return variables
        }
      )
    );

  }
  mapVariableFromService(item: object):IWorkflowProcessVariable {
    const variable:IWorkflowProcessVariable = {
      ...emptyWorkflowProcessVariable,
      id: item['id'],
      code: item['code']?item['code']:'',
      name: item['name']?item['name']:'',
      description: item['description']?item['description']:'',
      value: item['profile']
    };
    return variable;
  }

  mapStageFromService(item: object): IWorkflowProcessStage {
    const stage: IWorkflowProcessStage = {
      ...emptyWorkflowProcessStage,
      id: item['id'],
      name: item['name'],
      typeCode: item['type_code'],
      description: item['description'],

      processType: null,

      statusCode: item['status_code'],

      userIdCreated: item['user_id_created'],
      userNameCreated: '',
      userIdUpdated: item['user_id_updated'],
      userNameUpdated: '',

      dateCreate: moment(item['date_create'], 'YYYYMMDD').toDate(),
      dateUpdate: moment(item['date_update'], 'YYYYMMDD').toDate(),

      forms: [],
      actions: [],

      profile: item['profile']
    };
    if (stage.profile && stage.profile['forms']) {
      stage.forms= stage.profile['forms'].map(t=>({
        ...emptyWorkflowForm,
        title: t['title']?t['title']:'',
        tooltip: t['tooltip']?t['tooltip']:'',
        formCode: t['form_code']?t['form_code']:'',
        icon: t['icon']?t['icon']:'',
        profile: t
      }));
    }

    return stage;
  }

}
